export function formatPrice(value) {
  const num = parseFloat(value);
  if (isNaN(num)) return '—';
  if (num === 0) return '0';
  if (num >= 1000) return num.toLocaleString(undefined, { maximumFractionDigits: 2 });
  if (num >= 1) return num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  // For values < 1, show enough decimals to display 2 significant digits
  const decimals = Math.max(2, -Math.floor(Math.log10(Math.abs(num))) + 1);
  return num.toLocaleString(undefined, { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
}
